import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import classNames from "classnames";
import dayjs, { Dayjs } from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import { ApiRequest } from "../../../../state/api/ApiRequest";
import { CustomerCode } from "../../../../domain/care_recipient/CustomerCode";

export function TemperatureHumidityGraph(props: Props) {

    const { customerCode, targetDate } = props;

    const [data, setData] = useState<TemperatureHumidity[]>([]);

    const getData = async () => {
        if (!customerCode) {
            return;
        }
        const date = targetDate.format("YYYY-MM-DD");
        const data = await ApiRequest.get(
            `/api/temperature-humidity?customerCode=${customerCode.value}&date=${date}`,
            {},
            () => {},
            () => {}
        );
        setData(data);
    };

    useEffect(() => {
        getData();
    }, [customerCode, targetDate]);

    const tickFormatter = useCallback((timestamp: string) => {
        return dayjs(timestamp).format("HH:mm");
    }, []);

    const formatTemperature = useCallback((value: number) => {
        return `${value}℃`;
    }, []);

    const formatHumidity = useCallback((value: number) => {
        return `${value}%`;
    }, []);

    return (
        <div className={classNames("graph", "large")}>
            <h2 className={"title"}>{"温度・湿度"}</h2>
            <div className={"graph_area"}>
                <ResponsiveContainer height={"90%"} >
                    <LineChart
                        data={data}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="targetDate" tickFormatter={tickFormatter}/>
                        <YAxis yAxisId="temperature" tickFormatter={formatTemperature}/>
                        <YAxis yAxisId="humidity" orientation="right" tickFormatter={formatHumidity}/>
                        <Tooltip
                            formatter={(value, name) => {
                                if (name === "温度") return [`${value}℃`, "気温"];
                                if (name === "湿度") return [`${value}%`, "湿度"];
                                return [value, name];
                            }}
                            labelFormatter={(label) => dayjs(label).format("YYYY-MM-DD HH:mm")}
                        />
                        <Legend />
                        <Line yAxisId="temperature" type="monotone" dataKey="temperature" stroke="#FF6B6B" name="温度"/>
                        <Line yAxisId="humidity" type="monotone" dataKey="humidity" stroke="#4D96FF" name="湿度"/>
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export type TemperatureHumidity = {
    temperature: number;
    humidity: number;
    targetDate: string;
};

type Props = {
    customerCode: CustomerCode | null,
    targetDate: Dayjs,
}

